export const siteInfo = {
  name: "塌房档案局",
  slogan: "起底旧料，串起时间线，吃瓜不迷路",
  intro:
    "塌房档案局是一个专注整理网红塌房事件的档案型内容站。我们把散落在各处的旧料、过往言论与历史爆料归档成可读的时间线，帮你在信息洪流里快速理清一件事的来龙去脉。",
  email: "archive@tatafang-dangan.example.com",
};

export const navItems = [
  { label: "首页", href: "/" },
  { label: "塌房合集", href: "/cases" },
  { label: "关于与爆料", href: "/about" },
];

export const stats = [
  { label: "已归档事件", value: "128", suffix: "起" },
  { label: "整理旧料", value: "3,640", suffix: "条" },
  { label: "时间线还原", value: "316", suffix: "条" },
  { label: "活跃吃瓜用户", value: "42,000", suffix: "+" },
];

export const principles = [
  {
    icon: "ri-file-list-3-line",
    title: "只做整理，不下定论",
    desc: "我们负责把时间、言论与公开讨论归到同一条线上，结论留给你自己判断。",
  },
  {
    icon: "ri-links-line",
    title: "每一条旧料都可回溯",
    desc: "时间线上的每个节点都标注日期与来源类型，方便你顺着线索自己核对。",
  },
  {
    icon: "ri-shield-check-line",
    title: "化名呈现，克制表达",
    desc: "站内人物统一使用化名，只呈现网络公开讨论框架，不涉及个人隐私信息。",
  },
];

export const testimonials = [
  {
    name: "熬夜冠军小陈",
    role: "吃瓜三年用户",
    avatar:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20avatar%20of%20a%20cheerful%20young%20person%20with%20a%20coffee%20cup%2C%20soft%20cream%20background%2C%20warm%20terracotta%20accent%2C%20minimal%20geometric%20style%2C%20centered%20square%20composition%2C%20no%20text&width=200&height=200&seq=gua-user-t1&orientation=squarish",
    text: "以前看到塌房全靠碎片截图脑补，现在直接看时间线，五分钟就搞明白前因后果，太省事了。",
  },
  {
    name: "理性吃瓜的老王",
    role: "内容从业者",
    avatar:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20avatar%20of%20a%20calm%20middle%20aged%20man%20with%20glasses%2C%20soft%20cream%20background%2C%20muted%20teal%20accent%2C%20minimal%20geometric%20style%2C%20centered%20square%20composition%2C%20no%20text&width=200&height=200&seq=gua-user-t2&orientation=squarish",
    text: "最欣赏的是它不乱下结论，每条旧料都标了出处和日期，这点比很多只图流量的账号靠谱多了。",
  },
  {
    name: "瓜田里的兔子",
    role: "重度围观群众",
    avatar:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20illustration%20avatar%20of%20a%20playful%20young%20woman%20with%20a%20bun%20hairstyle%2C%20soft%20cream%20background%2C%20warm%20rose%20accent%2C%20minimal%20geometric%20style%2C%20centered%20square%20composition%2C%20no%20text&width=200&height=200&seq=gua-user-t3&orientation=squarish",
    text: "分类做得很细，言行打脸和抄袭搬运分开看，找同类事件效率高了不少。",
  },
];

export const faqs = [
  {
    q: "「塌房」在你们这里具体指什么？",
    a: "我们把它理解为网红公开形象与其公开言行、历史经历之间出现明显反差，并被大量网友讨论的事件。档案局只整理这类讨论的框架和时间线，不评价个人。",
  },
  {
    q: "站内的旧料和时间线是怎么整理的？",
    a: "编辑会先按时间收集公开可查的发言、采访与内容变更记录，再按发生顺序排进时间线，并在每个节点标注日期和来源类型，方便你自行核对。",
  },
  {
    q: "为什么站内人物都是化名？",
    a: "使用化名是为了把讨论聚焦在「事件」本身，而不是针对具体的个人。我们不鼓励对号入座，也不希望内容成为任何形式的网络攻击素材。",
  },
  {
    q: "发现的旧料和线索可以投稿吗？",
    a: "可以。在「关于与爆料」页面有投稿入口，填写事件简述和线索方向即可。编辑会先做来源核对，确认公开可查之后才会纳入整理队列。",
  },
  {
    q: "被整理的内容如果与事实有出入怎么办？",
    a: "可以通过页面底部的联系邮箱说明情况并提供依据。我们会在核对后对相关内容进行修订、补充说明或下架处理。",
  },
  {
    q: "时间线里的热度值代表什么？",
    a: "热度值反映的是事件在整理当期的讨论规模，由话题量、转载规模和持续时间综合得出，只是一个参考维度，并不代表我们的立场或评价。",
  },
];

export const siteTimeline = [
  {
    month: "2026.01",
    title: "档案局上线",
    desc: "第一版档案库发布，收录 12 起整理完成的塌房事件。",
  },
  {
    month: "2026.03",
    title: "时间线结构升级",
    desc: "引入「旧料时间线」与「过往言论」双栏结构，事件脉络更清晰。",
  },
  {
    month: "2026.06",
    title: "投稿通道开放",
    desc: "开放线索投稿入口，编辑团队开始对外部线索进行来源核对。",
  },
  {
    month: "2026.09",
    title: "五大分类体系成型",
    desc: "按虚假人设、言行打脸、抄袭搬运、带货翻车、数据注水完成归档。",
  },
];